/**
 * Create and render the submit overlay. This is not styled and placed as the last element in the form container.
 *
 * @param formDiv The HTML Element that contains the form container that contains the data-leadform-id element.
 * @returns The created overlay element.
 */
export const showSubmittingOverlay = (formDiv : Element) => {
  const gformDiv = formDiv.querySelector('.gform_wrapper');
  const overlay = generateOverlayHtml();
  gformDiv.appendChild(overlay);

  return overlay;
}

export const removeOverlay = (formDiv : Element, overlayDiv : Element) => {
  const gformDiv = formDiv.querySelector('.gform_wrapper');
  gformDiv.removeChild(overlayDiv)
}

const generateOverlayHtml = () => {
  const overlay = document.createElement(`div`);
  overlay.classList.add(`submit-overlay`);
  overlay.setAttribute(`title`, `Please wait while the form submits...`);

  return overlay;
}
